import styles from './footer.module.scss';
export const Footer = () => {
	return (
		<footer className={styles.footer}>
			<div className={styles.text}>主辦單位</div>
			<img
				src={`${process.env.PUBLIC_URL}/images/footer-logo.png`}
				alt='footer-logo'
			/>
		</footer>
	);
};
